import "core-js/modules/es.array.concat.js";
export var homeCrumb = function homeCrumb(userId, userRole, onClick) {
  return {
    text: 'Home',
    href: userRole === 'student' ? "/students/".concat(userId, "/dashboard") : userRole === 'agent' ? '/agent' : '/',
    onClick: onClick
  };
};
export var schoolCrumb = function schoolCrumb(schoolName, schoolSlug) {
  return {
    text: schoolName,
    href: "/schools/".concat(schoolSlug)
  };
};
export var programCrumb = function programCrumb(programName, programId) {
  return {
    text: "".concat(programName, " [").concat(programId, "]")
  };
};